declare global {
  interface Window {
    umami?: {
      track: (eventName: string) => void;
    };
  }
}

export default function sendUmamiTrackEvent({
  eventName,
}: {
  eventName: string;
}) {
  if (typeof window === "undefined") {
    return;
  }

  if (window.umami) {
    window.umami.track(eventName);
  }
}
